import { Box, Text } from '@factorialco/deprecated-design-system'

import { SimpleChipStyles } from './_SimpleChip.vanilla.css'

interface Props {
  label: string
  active: boolean
  onClick: () => void
}

const SimpleChip = ({ label, active, onClick }: Props) => {
  return (
    <Box
      className={SimpleChipStyles}
      paddingY="s4"
      paddingX="s12"
      borderRadius={{ all: 'abs008' }}
      border={{
        all: {
          color: active ? 'viridian1000' : 'grey400',
          width: 's2',
          style: 'solid',
        },
      }}
      background={active ? 'viridian100' : 'white'}
      onClick={onClick}
      component="button"
    >
      <Text.Normal
        color={active ? 'viridian1000' : 'grey800'}
        size="200"
        weight={active ? 'semibold' : 'normal'}
      >
        {label}
      </Text.Normal>
    </Box>
  )
}

export default SimpleChip
